<button
	matIconButton
	[matMenuTriggerFor]="menu"
	class="language-menu__button"
>
	<mat-icon class="material-symbols-rounded">{{ languageMenu.icon }}</mat-icon>
</button>

<mat-menu #menu="matMenu" xPosition="before">
	<div
		class="language-menu__menu"
		i18n="@@hub.global.language-menu-choice"
	>
		Choisissez votre langue :
	</div>
	@for (item of languageMenu.subMenu; track item.label) {
		<button
			mat-menu-item
			class="language-menu__menu-item"
			(click)="item.actionValue()"
		>
			{{ item.label }}
		</button>
	}
</mat-menu>
